import { toCtaData } from "@/contents/converters/atoms"
import BlokWrapper from "@/contents/integrations/BlokWrapper"
import { FeaturesList2 as FeaturesList2Content } from "@/contents/sanityTypes"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import SanityRichTextField from "@/integrations/sanity/components/SanityRichTextField"
import FeaturesList2 from "@/ui/organisms/FeaturesList2"

export interface SbFeaturesList2Props {
  content: FeaturesList2Content
}

const SbFeaturesList2 = ({ content }: SbFeaturesList2Props) => {
  return (
    <BlokWrapper contents={content} menuColor="paper">
      <FeaturesList2
        title={<SanityRichTextField value={content.title} />}
        items={content.featureBoxes?.map((item: any) => ({
          icon: <SanityImageField asset={item.icon} width={36} />,
          name: <SanityRichTextField value={item.name} />,
          label: <SanityRichTextField value={item.label} />,
        }))}
        layout={{
          backgroundColor: content.backgroundColor,
        }}
      />
    </BlokWrapper>
  )
}

export default SbFeaturesList2
